import { createFileRoute } from '@tanstack/react-router';

import { CommDiffReport } from '../../modules/ComponentsLibrary/CommDiffReport';

export const Route = createFileRoute('/reports/comm-diff')({
  component: CommDiffReport,
});
